import { Button } from '@/components/ui/button';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import {
  CONTENT_CATEGORY_LABELS,
  type ContentCategory,
} from '@shared/api.interface';

interface FilterTagsProps {
  category: ContentCategory | '';
  onCategoryChange: (value: ContentCategory | '') => void;
}

// 热门分类（显示在前面的几个）
const HOT_CATEGORIES: ContentCategory[] = [
  'traditional_culture',
  'idiom_fable',
  'classic_fairy_tale',
];

export function FilterTags({ category, onCategoryChange }: FilterTagsProps) {
  return (
    <ScrollArea className="w-full whitespace-nowrap">
      <div className="flex gap-2 py-1">
        <Button
          variant={category === '' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onCategoryChange('')}
          className="rounded-full text-xs shrink-0"
        >
          全部
        </Button>
        {HOT_CATEGORIES.map((key) => (
          <Button
            key={key}
            variant={category === key ? 'default' : 'outline'}
            size="sm"
            onClick={() => onCategoryChange(key)}
            className="rounded-full text-xs shrink-0"
          >
            {CONTENT_CATEGORY_LABELS[key]}
          </Button>
        ))}
      </div>
      <ScrollBar orientation="horizontal" className="invisible" />
    </ScrollArea>
  );
}
